import React, { Component } from 'react';
import {
  Modal, 
  ModalBody, 
  ModalHeader,
  CardFooter,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';


class Terms extends Component{
  constructor(props){
	    super(props);
	    this.state={
	    	modal : 1
	    }
  }

  openModel = (event) => {
      this.setState({ modal: 1});
    }

  closeModel = (event) => {
      this.props.handleFunction();
  }

  render(){
    const { t } = this.props;
  	return(
  		<div>
  				  <Modal isOpen={this.state.modal} toggle={this.openModel.bind(this)} onClickAway={this.closeModel.bind(this)}  style={{backgroundColor:'#2eb85c'}} className="modal-lg">
                            <ModalHeader style={{backgroundColor:'#56B4D3'}} >
                              <h5 className="m-0 text-dark" > <strong> شروط القبول وشروط التسجيل</strong> </h5>
                            </ModalHeader>
                            <ModalBody>
                               <p style={{textAlign:"right"}}>
                                    شروط الالتحاق<br />
                                        أسعار الدورات قابلة للتغير علماً بأن في حالة الحجز علي السعر القديم والطالب لم يلتحق بالدورة يطبق عليه الأسعار الجديدة.<br />􀂉
                                        الدراسة الفنية باللغة العربية و علي المتقدمين الأجانب الإلمام باللغة العربية آتابة و قراءة و محادثةً.الحجز و دفع المبلغ بالكامل قبل بداية الدورة بشهر و بأسبقية الحجز مع 􀂉
                                        إحضار صورة البطاقة الشخصية و عدد صور ةواحدة لعمل الكارنية.<br />
                                        ضرورة حضور الطالب المقابلة لمعرفة المواعيد حتى لا يتم استبعاده أو تأجيل دورته بسبب تخلفه عن حضوره المقابلة حتى وان آان قد سدد الرسوم بالكامل حسب ميعاد آل دورة 􀂉
                                        قد سجل فيها آما هو مدون بجدول مواعيد المقابلة للبرنامج الشهري للدورات ولا يعتبر يوم المقابلة اليوم الفعلي لبدء الدورة وذلك لوجود أجازات قد تمت خلال الفترة السابقة لكل
                                        دورة و يتم حساب عدد الساعات بدء من اليوم الذي يحدد يوم المقابلة و في حالة عدم اآتمال العدد المطلوب لبداية الدورة أو لظروف قهرية يتم تأجيل الدورة.<br />
                                        الشرآات و الهيئات تدفع المصاريف بالكامل قبل بداية الدورة بعشرة أيام علي الأقل و الحجز قبل بداية الدورة بشهر و بأولوية الحجز و في حالة الانسحاب قبل بداية الدورة لا يحق 􀂉
                                        للمتدرب استلام المبلغ إلا بخطاب رسمي من الجهة التي يعمل بها و تسلم الشهادات بموجب خطاب رسمي من الشرآة يفيد تسليم الشهادة للطالب من عدمه.<br />
                                        معرفة الرسوم المقررة و الالتزام بسدادها و معرفة مواعيد الدورة و التدريب و النظام العام علماً بأن الفصل الدراسي هو مكان مقدس لتلقي العلم و يجب احترامه و لذلك فأنه ممنوع 􀂉
                                        التدخين و استخدام الموبايل أثناء الدراسة و يستخدم أثناء الراحة فقط حتى لا يتعرض المخالف للفصل النهائي.<br />
                                        شروط دورة التحكم الآلي ( آنترول ) : لابد من اجتياز اختبار آهرباء ترآيبات و يتم إعلان مواعيد الاختبار لدي السكرتارية و قيمة الاختبار عشرة جنيهات فقط لا غير و عند اجتياز 􀂉
                                        الطالب الاختبار و معرفة المواعيد و دفع قيمة الدورة و تسجيله في الدورة ليس من حقه الانسحاب تحت أي ظرف.<br />
                                        شروط القبول في دورة الإلكترونيات : لابد من اجتياز اختبار آهرباء عامة ( الدوائر الكهربائية ).<br /> 􀂉
                                        لابد من اجتياز اختبار آهرباء تحكم آلي آنترول و يتم عمل الاختبار يوم المقابلة P .L. C شروط دورة<br /> 􀂉
                                        لابد من اجتياز اختبار إحداثيات الرسم الفني و يتم عمل الاختبار يوم المقابلة. C.N.C شروط دورة التحكم الرقمي<br /> 􀂉
                                        شروط دورة لحام أنابيب بترول : لابد من اجتياز اختبار لحام أآسجين و آهرباء مع دفع ثمانون جنيهاً رسوم الاختبار و يحدد يوم المقابلة . ملحوظة : لا يخصم ثمن الاختبار من 􀂉
                                        إجمالي الدورة في حالة النجاح آو الرسوب في الاختبار<br />
                                        تمنح إفادة اجتياز المستوي للغة الايطالية لكل مستوي علي حدة و منح شهادة معتمدة للغة الايطالية بعد اجتياز المستوي الرابع فقط.<br /> 􀂉
                                        تحديد المستوي للغة الإيطالية يومي السبت و الثلاثاء من آل أسبوع الساعة ٥.م عدا يوم المقابلة و قيمة الاختبار عشرة جنيهات.<br /> 􀂉
                                        في حالة الانسحاب من الدورة لابد من تقديم الإيصال و البطاقة الشخصية و لا يرد المبلغ إلا بالإيصال على أن يخصم الآتي للطالب الذي لا تتناسب مواعيده مع مواعيد الدورة الانسحاب 􀂉
                                        في نفس يوم الاجتماع و يستلم المبلغ بالكامل وإلا سوف يخصم ٢٥ % من قيمة الدورة وبعد مرور يوم واحد من الاجتماع يخصم ٥٠ % من الرسوم المقررة ثالث يوم من الاجتماع<br />
                                        و بعد مرور الثلاث أيام الأولى من الاجتماع لا يحق للمتدرب المطالبة بأي مبلغ تم دفعه . يفصل الطالب لسوء السلوك و بعد اربعة مرات غياب آو تأخير أيهما اقرب وفي نهاية الدورة<br />
                                        يمنح الطالب شهادة خبرة بعد اجتياز الاختبارات وأقل درجة للنجاح هي ٦٠ % ستون بالمائة وقيمة الشهادة عشرة جنيهات تدفع عند استلام الشهادة في حالة النجاح ولا يوجد إعادة<br />
                                        للاختبار و تسلم الشهادات بعد ثلاث أسابيع تقريباً من النتيجة و ليس من حق المتدرب المطالبة بالشهادة بعد مرور ستة أشهر من ظهور النتيجة و يتقدم بطلب مستخرج رسمي بعد
                                        دفع رسوم الشهادة .
                               </p>
                            </ModalBody>
                             <CardFooter>
                               <div className="row">
                                <div className="col-md-10 col-sm-10"> </div>
                                <div className="col-md-2 col-sm-2"><button type="button" className="btn  btn-primary " onClick={this.closeModel.bind(this)} title={t("term_place")}>{t("term_close")}</button></div>
                              </div>
                             </CardFooter>
                </Modal>
  		</div>
  	)
  }
}

export default withTranslation() (Terms)